import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'messenger',
  titolo: 'Messenger',
  gruppo: 'Comunicazione',
  permesso: 'chat.usa',
  aCheServe: 'Il messenger serve a scrivere ai colleghi di CIDIS. Si apre dentro il gestionale, senza un’altra '
    + 'password, ed è cifrato: i messaggi li leggono solo i partecipanti. **Mai dati dei beneficiari nei messaggi.**',
  parti: [
    {
      titolo: 'Aprire il messenger',
      passi: [
        'Premi la voce «Messenger».',
        'A sinistra trovi lo spazio CIDIS («Generale CIDIS», «Avvisi CIDIS») e lo spazio della tua sede, con '
          + '«Generale» e «Avvisi». Negli «Avvisi» scrivono Direzione, coordinatori e Project Manager.',
        'Gli spazi delle altre sedi sono in «Esplora stanze»: scegli quello che ti serve ed entra con un clic.',
        'Puoi scrivere in privato a un collega o creare un gruppo privato.',
        'Chi ha il rapporto esterno con CIDIS compare come «Nome Cognome (esterno)».',
      ],
      immagine: {
        file: 'messenger.webp',
        descrizione: 'Il messenger aperto dentro il gestionale, con gli spazi CIDIS e della sede.',
        daFare: true,
        cosaMostra: 'Pagina «Messenger» con il messenger aperto: a sinistra lo spazio CIDIS e lo spazio di una sede, '
          + 'in alto «Apri in una finestra separata». Serve il server del messenger: utente di prova di una sede '
          + 'di formazione, senza messaggi veri.',
      },
    },
    {
      titolo: '«Apri in una finestra separata»',
      passi: [
        'In alto nella pagina premi «Apri in una finestra separata»: il messenger si sposta in una finestra a '
          + 'parte, da tenere accanto al gestionale.',
        'Quando chiudi quella finestra, nella pagina premi «Riportalo qui».',
      ],
    },
    {
      titolo: 'La chiave di recupero',
      testo: [
        'Al primo accesso il messenger chiede di impostare il «Backup sicuro»: **salva la chiave di recupero** in '
          + 'un posto sicuro. Ogni nuovo accesso (un altro computer, il telefono) la chiede per leggere i messaggi '
          + 'vecchi. Senza chiave nessuno può recuperare quei messaggi.',
      ],
    },
    {
      titolo: 'Parlare di una persona senza scriverne il nome',
      passi: [
        'Apri la scheda della persona e premi «Riferimento per il messenger».',
        'Si copiano il numero della scheda e il collegamento, senza il nome.',
        'Incollali nel messaggio. Chi li apre vede la scheda solo se il suo incarico la copre.',
      ],
      nota: 'L’unica chat in cui si parla della persona è la chat riservata della sua scheda.',
    },
    {
      titolo: 'Gli avvisi dei messaggi diretti',
      testo: [
        'Quando un collega ti scrive in una chat a due, nel gestionale compare «Nuovo messaggio nel messenger»: in '
          + 'basso a destra, come notifica del computer se le hai attivate, e sul telefono con l’app CIDIS. Un clic '
          + 'apre il messenger. L’avviso non dice chi ti ha scritto né che cosa.',
        'Arriva al massimo un avviso ogni quarto d’ora per chat, e nessuno per i gruppi e i canali. Con il messenger '
          + 'aperto nella pagina «Messenger» il riquadro non compare.',
      ],
      nota: 'Per non ricevere gli avvisi di una chat, silenziala in Element: il gestionale segue le stesse regole.',
    },
    {
      titolo: 'Sul telefono: Element Classic',
      testo: [
        'Sul telefono il messenger si usa con l’app **Element Classic**. **Non Element X**: con l’accesso del '
          + 'gestionale non entra. Gli stessi passi, con il collegamento allo store giusto, sono in cima alla pagina '
          + '«Messenger» quando la apri dal telefono e nel riquadro «App per il telefono» di «Il mio profilo».',
      ],
      passi: [
        'Installa Element Classic: per iPhone dall’App Store, per Android da Google Play.',
        'Apri Element Classic, scegli di accedere e cambia il server: scrivi matrix.cidiserp.france4.honeymolly.net.',
        'Tocca «Gestionale CIDIS», senza scrivere nome utente e password nei campi di Element. Sull’iPhone, se il '
          + 'telefono chiede di consentire a Element di usare il sito per l’accesso, tocca «Continua».',
        'Nel browser del telefono si apre l’accesso del gestionale: entra con nome utente, password e, se l’hai '
          + 'attivato, il codice del secondo fattore. Se in quel browser sei già entrato nel gestionale, questo passo '
          + 'non c’è.',
        'Il messenger chiede di confermare l’accesso di Element, con una pagina in inglese: tocca «Continue». '
          + 'Element si riapre, già collegato.',
        'Element chiede di confermare il nuovo dispositivo. Apri il messenger dove sei già entrato la prima volta, di '
          + 'solito il gestionale sul computer, pagina «Messenger»: compare la richiesta di verificare il nuovo accesso. '
          + 'Accettala e controlla che le emoji sul telefono e sul computer siano le stesse; se coincidono, confermalo su '
          + 'tutti e due.',
        'Senza un altro dispositivo collegato, sul telefono scegli la chiave di recupero e scrivila. Senza conferma i '
          + 'messaggi vecchi restano illeggibili.',
      ],
    },
  ],
  avvertenze: [
    {
      quando: 'Hai perso la chiave di recupero.',
      cosaFare: 'I messaggi vecchi non si leggono più su un nuovo dispositivo, e nessuno li può recuperare. Non '
        + 'uscire dal messenger sui dispositivi dove sei ancora collegato.',
    },
    {
      quando: 'Con Element X non riesci a entrare.',
      cosaFare: 'Element X non funziona con l’accesso del gestionale. Installa Element Classic e segui i passi qui sopra.',
    },
    {
      quando: 'Sul telefono compare «Non hai accesso al messenger».',
      cosaFare: 'Il messenger è riservato al personale con un incarico che lo prevede. Se ti serve, chiedi a chi '
        + 'gestisce gli utenti.',
    },
    {
      quando: 'Non vedi lo spazio di una sede.',
      cosaFare: 'Cercalo in «Esplora stanze». Il tuo spazio di sede dipende dalle sedi della tua utenza.',
    },
  ],
  vediAnche: ['area-riservata', 'posta', 'telefono'],
  parole: ['chat', 'messaggi', 'element', 'matrix', 'whatsapp', 'avvisi', 'chiave di recupero', 'finestra',
    'element classic', 'element x', 'telefono', 'iphone', 'android'],
}

export default capitolo
